import styled from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { toRem } from '@/config/layout'

const AdditionalContactCard = styled(FlexColumn)`
  width: 100%;
  color: ${({ theme }) => theme.Colors.Neutrals.Darkest};
  background-color: ${({ theme }) => theme.Colors.Neutrals.Lighter};
  border-radius: ${({ theme }) => toRem(theme.UI.BorderRadius.Small)};
  border: 1px solid ${({ theme }) => theme.Components.Card.Border};
`

const AdditionalContactCardContent = styled(FlexColumn)`
  padding: ${({ theme }) => `${toRem(theme.UI.Spacing.Space3)} ${toRem(theme.UI.Spacing.Space6)}`};
`

const AdditionalContactCardAction = styled(Button).attrs({
  variant: 'Tertiary',
  prefixIcon: ['fal', 'user-pen'],
  inline: true,
})`
  padding: 0;
  min-height: auto;
  justify-content: flex-start;
`

export { AdditionalContactCard, AdditionalContactCardAction, AdditionalContactCardContent }
